

import eventManagerReducer from './EventManagerReducer'
export { eventManagerReducer }

export * from './EventManagerActions'



// WEBPACK FOOTER //
// ./src/store/event-manager/index.js